import { createActionTypes } from '../_utils'

export default createActionTypes(
  [
    'LOGIN',
    'LOGOUT',
    'SET_BRAND_LIST',
    'FETCH_BRAND_LIST',
    'SET_STORE_CHANNEL',
    'FETCH_STORE_CHANNEL',
    'SET_REGISTER_CHANNEL',
    'FETCH_REGISTER_CHANNEL',
    'RESET_USER',
    'RESET_USER_INFO',
    'UPDATE_AUTH_CODES'
  ],
  'USER'
)
